function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 3");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\uD83D\\uDDA5-Wireframes-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-1540.000000, -2186.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(1540.000000, 2185.000000)"
}, React.createElement("g", {
  id: "Group-15"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(24.500000, 12.750000) rotate(-270.000000) translate(-24.500000, -12.750000) translate(12.500000, 10.250000)",
  fill: "#009BDF"
}, React.createElement("path", {
  d: "M20.5248815,9.09494702e-13 L18.5082938,9.09494702e-13 C18.5082938,9.09494702e-13 18.5082938,9.09494702e-13 18.5082938,9.09494702e-13 L4.50118483,9.09494702e-13 C4.39218009,9.09494702e-13 4.33767773,0.0510204082 4.28317536,0.0510204082 L4.28317536,0.0510204082 L0.25,2.5 L4.28317536,4.94897959 L4.28317536,4.94897959 C4.33767773,5 4.44668246,5 4.50118483,5 L18.5082938,5 C18.5082938,5 18.5082938,5 18.5082938,5 L20.5248815,5 C21.9964455,5 23.25,3.87755102 23.25,2.44897959 C23.25,1.02040816 22.0509479,9.09494702e-13 20.5248815,9.09494702e-13 Z M18.1267773,0.765306122 L18.1267773,2.14285714 L4.88270142,2.14285714 L4.88270142,0.765306122 L18.1267773,0.765306122 Z M4.25,1.5 L4.25,3.5 L2.25,2.51754386 L4.25,1.5 Z M4.88270142,2.90816327 L18.0722749,2.90816327 L18.0722749,4.28571429 L4.88270142,4.28571429 L4.88270142,2.90816327 Z M20.6346154,4 L19.25,4 L19.25,1 L20.6346154,1 C21.5115385,1 22.25,1.69565217 22.25,2.52173913 C22.25,3.34782609 21.5576923,4 20.6346154,4 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.75,
  y: 0.5,
  width: 14,
  height: 4
})), React.createElement("g", {
  id: "e4h/assignment",
  transform: "translate(4.000000, 1.000000)"
}, React.createElement("g", {
  id: "assignment"
}, React.createElement("g", {
  id: "Rectangle"
}, React.createElement("path", {
  d: "M27.2536256,3.1586306 L29.1427761,3.18797332 C29.4856096,3.19329829 29.7592143,3.4755365 29.7538893,3.81837002 C29.7535697,3.83894589 29.7522273,3.85949314 29.7498671,3.87993568 C29.7119688,4.20817511 29.9473369,4.50498832 30.2755763,4.54288653 C30.3025617,4.54600224 30.3297279,4.54727643 30.3568865,4.54670028 L36.6847942,4.41245642 C36.994614,4.40588373 37.2404443,4.14939697 37.2338716,3.83957721 C37.2333841,3.81659877 37.2314853,3.79367199 37.2281858,3.77092645 C37.1846403,3.47074075 37.3926884,3.19209159 37.6928741,3.14854614 C37.7189853,3.1447584 37.7453356,3.14285714 37.7717201,3.14285714 L39.7619048,3.14285714 C40.3141895,3.14285714 40.7619048,3.59057239 40.7619048,4.14285714 L40.7619048,20.7582418 C40.7619048,21.3105265 40.3141895,21.7582418 39.7619048,21.7582418 L27.2380952,21.7582418 C26.6858105,21.7582418 26.2380952,21.3105265 26.2380952,20.7582418 L26.2380952,4.15850999 C26.2380952,3.60622524 26.6858105,3.15850999 27.2380952,3.15850999 C27.2432723,3.15850999 27.2484492,3.15855019 27.2536256,3.1586306 Z",
  fill: "#009BDF"
}), React.createElement("path", {
  d: "M28.55,9 L38.45,9 C38.7540039,9 39,8.5527344 39,8 C39,7.4472656 38.7540039,7 38.45,7 L28.55,7 C28.2459961,7 28,7.4472656 28,8 C28,8.5527344 28.2459961,9 28.55,9 Z",
  id: "Path-Copy",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M28.55,17 L38.45,17 C38.7540039,17 39,16.5527344 39,16 C39,15.4472656 38.7540039,15 38.45,15 L28.55,15 C28.2459961,15 28,15.4472656 28,16 C28,16.5527344 28.2459961,17 28.55,17 Z",
  id: "Path-Copy-4",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M28.35,13 L34.65,13 C34.843457,13 35,12.5527344 35,12 C35,11.4472656 34.843457,11 34.65,11 L28.35,11 C28.156543,11 28,11.4472656 28,12 C28,12.5527344 28.156543,13 28.35,13 Z",
  id: "Path-Copy-3",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M1.05,11 L10.95,11 C11.2540039,11 11.5,10.5527344 11.5,10 C11.5,9.4472656 11.2540039,9 10.95,9 L1.05,9 C0.74599608,9 0.5,9.4472656 0.5,10 C0.5,10.5527344 0.74599608,11 1.05,11 Z",
  id: "Path-Copy",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Mask",
  transform: "translate(26.000000, 0.000000)",
  fill: "#009BDF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M7.49995932,0 C7.02038575,0 6.56807455,0.18988882 6.22603353,0.535126206 C5.88618978,0.880198322 5.6990153,1.33963343 5.6990153,1.82865085 L5.6990153,1.85889423 C4.87568157,1.91483624 4.162913,2.38269981 3.75522868,3.05970552 L1.01420085,3.05970552 C0.516560883,3.05970552 0.111694333,3.47071814 0.111694333,3.97609676 L0.111694333,21.0295673 C0.111694333,21.5646935 0.540405267,22 1.0674235,22 L13.9325765,22 C14.4595947,22 14.8883057,21.5646935 14.8883057,21.0295673 L14.8883057,3.97609676 C14.8883057,3.47071816 14.4834391,3.05970552 13.9857992,3.05970552 L11.2447103,3.05970552 C10.8370463,2.38269981 10.1243184,1.91483624 9.3009847,1.85889423 L9.3009847,1.82865085 C9.3009847,0.820372605 8.493042,0 7.49995932,0 Z M13.9857992,3.39816706 C14.2996826,3.39816706 14.5549723,3.65746695 14.5549723,3.97609676 L14.5549723,21.0295673 C14.5549723,21.37811 14.2757568,21.6615385 13.9325765,21.6615385 L1.0674235,21.6615385 C0.724243167,21.6615385 0.445027667,21.37811 0.445027667,21.0295673 L0.445027667,3.97609676 C0.445027667,3.65746695 0.700317383,3.39816706 1.01420085,3.39816706 L3.583903,3.39816706 C3.4609782,3.69609749 3.39196778,4.0224121 3.39196778,4.3651292 L3.39196778,4.52692308 C3.39196778,4.62046274 3.46659343,4.69615385 3.55863445,4.69615385 L11.4412842,4.69615385 C11.5333252,4.69615385 11.6079509,4.62046274 11.6079509,4.52692308 L11.6079509,4.3651292 C11.6079509,4.0224121 11.5389404,3.69609751 11.4160258,3.39816706 L13.9857992,3.39816706 Z M10.7142857,4.4 L4.28571429,4.4 C4.28910993,3.41881991 5.10544965,2.62163652 6.10834173,2.62163652 C6.18671866,2.62163652 6.25026565,2.55949014 6.25026565,2.48268915 L6.25026565,2.32352385 C6.25026565,1.99623766 6.38013158,1.68876234 6.61560887,1.45822368 C6.85302651,1.22727796 7.16708862,1.1 7.50000001,1.1 C8.18917645,1.1 8.74980365,1.64886924 8.74980365,2.32352385 L8.74980365,2.48268915 C8.74980365,2.55949014 8.81335064,2.62163652 8.89172757,2.62163652 C9.89461965,2.62163652 10.7108901,3.41881991 10.7142857,4.4 Z",
  id: "Shape"
}))))), React.createElement("g", {
  id: "Group-13",
  transform: "translate(0.000000, 3.000000)"
}, React.createElement("path", {
  d: "M2.86090542,16.5367337 C0.992710333,14.6835818 -0.0234427416,12.2332145 0.000410605053,9.63636043 C0.023786915,7.03903682 1.08478432,4.60557188 2.98780528,2.7848161 C6.91788469,-0.975950684 13.2576304,-0.920548614 17.118535,2.90782746 C20.9298247,6.68831362 20.9646506,12.6398093 17.196774,16.4583257 C17.1295076,16.526874 17.0608099,16.5940138 16.9916351,16.6602145 C16.9787543,16.6724217 16.9668277,16.6850985 16.9558551,16.6982448 C16.3747873,17.3898315 16.3681083,18.0095833 16.4644759,18.4081964 C16.6075961,18.9974301 17.0450666,19.4561404 17.4663169,19.775876 C14.9979713,20.5219258 13.6268803,19.171618 13.5653386,19.1091733 C13.4713564,19.0110459 13.3425482,18.9579914 13.2099235,18.9579914 C13.1603085,18.9579914 13.1102165,18.9655036 13.0615557,18.9805278 C9.4363223,20.1176786 5.52675683,19.1814777 2.86090542,16.5367337 Z",
  id: "Path",
  fill: "#009BDF"
}), React.createElement("path", {
  d: "M5.05,9 L14.95,9 C15.2540039,9 15.5,8.5527344 15.5,8 C15.5,7.4472656 15.2540039,7 14.95,7 L5.05,7 C4.74599608,7 4.5,7.4472656 4.5,8 C4.5,8.5527344 4.74599608,9 5.05,9 Z",
  id: "Path-Copy",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M5.05,13.3882353 L14.95,13.3882353 C15.2540039,13.3882353 15.5,12.9409697 15.5,12.3882353 C15.5,11.8355009 15.2540039,11.3882353 14.95,11.3882353 L5.05,11.3882353 C4.74599608,11.3882353 4.5,11.8355009 4.5,12.3882353 C4.5,12.9409697 4.74599608,13.3882353 5.05,13.3882353 Z",
  id: "Path-Copy-2",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))), React.createElement("g", {
  id: "Group-2",
  transform: "translate(48.000000, 6.000000)",
  fill: "#009BDF",
  stroke: "#009BDF",
  strokeWidth: 1.125
}, React.createElement("circle", {
  id: "Oval-Copy",
  cx: 5.25,
  cy: 3.75,
  r: 3
}), React.createElement("circle", {
  id: "Oval-Copy-3",
  cx: 12.75,
  cy: 3.75,
  r: 3.75
}), React.createElement("circle", {
  id: "Oval-Copy-2",
  cx: 20.25,
  cy: 3.75,
  r: 3
}), React.createElement("path", {
  d: "M4.875,7.5 C7.56738816,7.5 9.75,9.68261184 9.75,12.375 L9.75,13.5 L9.75,13.5 L0,13.5 L0,12.375 C-3.29722454e-16,9.68261184 2.18261184,7.5 4.875,7.5 Z",
  id: "Rectangle-Copy"
}), React.createElement("path", {
  d: "M20.625,7.5 C23.3173882,7.5 25.5,9.68261184 25.5,12.375 L25.5,13.5 L25.5,13.5 L15.75,13.5 L15.75,12.375 C15.75,9.68261184 17.9326118,7.5 20.625,7.5 Z",
  id: "Rectangle-Copy-2"
}), React.createElement("path", {
  d: "M12,8.25 C15.3137085,8.25 18,10.9362915 18,14.25 L18,15 L18,15 L6,15 L6,14.25 C6,10.9362915 8.6862915,8.25 12,8.25 Z",
  id: "Rectangle"
})))));

var SvgTypesSm = function SvgTypesSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "75px",
    height: "23px",
    viewBox: "0 0 75 23",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTypesSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/types_sm.5fff371f.svg";
export { ForwardRef as ReactComponent };